import { useStats } from '../contexts/StatsContext';
import { getDisclaimer } from '../utils/config';
import { getContact } from '../utils/config';

function Footer() {
  const stats = useStats();
  const disclaimer = getDisclaimer();
  const email = getContact();
  // 将免责声明分成三部分：删除数字前的文本、删除数字、删除数字后的文本
  const renderDisclaimer = () => {
    const parts = disclaimer.split('%delete_num%');
    
    if (!stats)
    {
      return (
        <>
          {parts[0]}
          <span className="highlight-number">今日失效0条</span>
          {parts[1]}
        </>
      );
    }
    
    return (
      <>
        {parts[0]}
        <span className="highlight-number">今日失效{stats.today_delete}条</span>
        {parts[1]}
      </>
    );
  };

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <p>{renderDisclaimer()}{email}</p>
        </div>
          <div className="online-users">
            当前在线: 😁🤣😁🤣  人
          </div>
          <div className="copyright">2024 All Rights Reserved</div>
      </div>
    </footer>
  );
}

export default Footer;